//import React from 'react';
import React, { useState, } from "react";
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';

class FlatListSeanceItem extends React.Component {

  state = {
    showItem: false
  };

  _onPress = index => () => {
      let showItem = this.state.showItem;
      showItem = !this.state.showItem;
      this.setState({ showItem });
    };

  render() {
    // const seance = this.props.seance;
    const {seance, couleur} = this.props;

    var allImages = {
      BondissementsMultidirectionnels:require('../img/BondissementsMultidirectionnels.png'),
      BondissementsVerticaux:require('../img/BondissementsVerticaux.png'),
      Corde:require('../img/Corde.png'),
      EchauffementRusseMolletsCuisses:require('../img/EchauffementRusseMolletsCuisses.png'),
      Footing:require('../img/Footing.png'),
      RenforcementConcentriqueCuisses:require('../img/RenforcementConcentriqueCuisses.png'),
      RenforcementConcentriqueMollets:require('../img/RenforcementConcentriqueMollets.png'),
      SkipingLateraux:require('../img/SkipingLateraux.png'),
      Etir_PsoasIliaque:require('../img/Etir_PsoasIliaque.png'),
      Etir_Fessiers:require('../img/Etir_Fessiers.png'),
      Etir_BandeletteIlioTibiale:require('../img/Etir_BandeletteIlioTibiale.png'),
      Etir_Ischios:require('../img/Etir_Ischios.png'),
      Etir_Quadriceps:require('../img/Etir_Quadriceps.png'),
      Etir_Mollets:require('../img/Etir_Mollets.png'),
    };

       return (
         <View style={{flex: 1}}>

      {this.state.showItem ?
        <View style={{borderColor: 'black', borderWidth: 7, backgroundColor: seance.couleur, }} >
          <TouchableOpacity onPress={this._onPress(this.props.index)}>
            <View style={{flexDirection: 'row', backgroundColor: seance.couleur,}}>
              <View style={[styles.content_container_title,{ backgroundColor: seance.couleur}]}>
                <View style={{borderWidth:1, borderColor: 'black'}}>
                <View style={{borderWidth:2, borderColor: couleur}}>
                  <Text style={[styles.titre,{ backgroundColor: seance.couleur, padding:3}]}>{seance.Activités}</Text>
                </View>
                </View>
                <Text style={[styles.soustitre_select,{ backgroundColor: seance.couleur, padding: 5}]}>{seance.Séances}</Text>
              </View>
            </View>
            {(seance.Exercices=='') ?
              null :
            <View style={{backgroundColor: '#EEEEEE',}}>
              <Text style={{fontSize:5, textAlign:'center', color: 'red'}}>{"\nzzzzzzzzzzzzzzzzzz"}</Text>
              <Text style={{textAlign:'center'}}>{seance.Exercices}</Text>
              <Text style={{fontSize:5, textAlign:'center', color: 'red'}}>{"zzzzzzzzzzzzzzzzzz"}</Text>
            </View>
            }
               <View style={{flexDirection: 'row', backgroundColor: '#EEEEEE',}}>
                  <View style={[styles.content_container,{ backgroundColor: '#EEEEEE', flex: 10}]}>
                    <Text style={{ backgroundColor: '#EEEEEE'}} >{seance.Description}</Text>
                  </View>
                  <Image
                    style={[styles.image,{ backgroundColor: '#EEEEEE', textAlign: 'right',}]}
             				source={allImages[""+seance.image]}
             				resizeMode="contain"
                  />
                </View>
             </TouchableOpacity>
            </View>
        :
          <View style={{borderColor: 'black', borderWidth: 1, backgroundColor: seance.couleur, }} >
            <TouchableOpacity onPress={this._onPress(this.props.index)}>
              <View style={{flexDirection: 'row', backgroundColor: seance.couleur}}>
                <View style={[styles.content_container_title,{ backgroundColor: seance.couleur}]}>
                  <View style={{borderWidth:1, borderColor: 'black'}}>
                  <View style={{borderWidth:2, borderColor: couleur}}>
                    <Text style={[styles.titre,{ backgroundColor: seance.couleur, padding:3}]}>{seance.Activités}</Text>
                  </View>
                  </View>
                  <Text style={[styles.soustitre_select,{ backgroundColor: seance.couleur, padding: 5}]}>{seance.Séances}</Text>
                </View>
              </View>
              <View>
                <Text style={{fontSize:5}}>{"\n"}</Text>
              </View>
               </TouchableOpacity>
              </View>
        }

</View>
       )
   }
}

const styles = StyleSheet.create({
  image: {
      width: 120,
      height: 120,
      //margin: 5,
      //backgroundColor: '#FFF0BC',
      //flex: 1,
  },
  content_container: {
      //flex: 2,
      margin: 5,
      //justifyContent: 'space-around',
      //alignItems: 'center',
      //justifyContent: 'center',
      flexDirection: 'column',
      //backgroundColor: 'red',
    },
    content_container_title: {
        flex: 2,
        margin: 5,
        justifyContent: 'space-between',
        //alignItems: 'center',
        //justifyContent: 'center',
        flexDirection: 'row',
        //backgroundColor: 'red',
      },
  titre: {
      fontWeight: 'bold',
      //height: 20,
      //backgroundColor: 'lightgray',
      //backgroundColor: '#DDFDDF',
      textAlign: 'center',
      //alignItems: 'center',
      //justifyContent: 'center',
      //flex: 1,
      textAlignVertical:'center',
      //borderColor: 'black',
      //borderWidth: 1,
  },
  soustitre: {
      fontWeight: 'bold',
      //height: 20,
      backgroundColor: 'lightyellow',
      //backgroundColor: '#FFDDDD',
      //alignItems: 'center',
      justifyContent: 'center',
      //marginTop: 10,
      textAlign: 'right',
      textAlignVertical:'center',
      //flex: 2,
  },
  soustitre_select: {
      fontWeight: 'bold',
      //height: 20,
      backgroundColor: '#FFF0BC',
      //alignItems: 'center',
      justifyContent: 'center',
      //marginTop: 10,
      textAlign: 'right',
      textAlignVertical:'center',
      flex: 2,
  },
});

export default FlatListSeanceItem
